"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Property = void 0;
var Property = /** @class */ (function () {
    function Property(label, values, valueType, uri, column) {
        this.label = label;
        this.values = values;
        this.valueType = valueType;
        this.uri = uri;
        this.column = column;
    }
    Property.prototype.addValue = function (value) {
        this.values.push(value);
    };
    return Property;
}());
exports.Property = Property;
